import { lazy } from "react";
import { REPORTS } from "pages/routes/route.constant";
const reports = lazy(() => import("pages/Reports"));

export default {
  path: REPORTS,
  element: reports,
};
